export default __webpack_public_path__ + "static/fly-man-7307b020505ec7bfd3e24b6ccf785295.webp";